import {
  GET_TRANSFER_PACK,
  GET_TRANSFER_PACK_SUCCESS,
  GET_TRANSFER_PACK_FAILURE,
} from "./constants";

// payload = resident UUID
export const getTransferPack = (payload, onSuccess) => ({
  type: GET_TRANSFER_PACK,
  payload,
  onSuccess,
});
export const getTransferPackSuccess = (payload) => ({
  type: GET_TRANSFER_PACK_SUCCESS,
  payload,
});
export const getTransferPackFailure = (payload) => ({
  type: GET_TRANSFER_PACK_FAILURE,
  payload,
});
